import { useCallback, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { copyTextToClipboard } from "../utils/clipboard";
import { buildProfileShareUrl } from "../utils/profileRoutes";

export default function useProfileShare(profile) {
    const { t } = useTranslation();
    const toastIdRef = useRef(0);
    const [toast, setToast] = useState(null);

    const showToast = useCallback((message, type = "info") => {
        toastIdRef.current += 1;
        setToast({
            id: toastIdRef.current,
            message,
            type,
        });
    }, []);

    const shareProfile = useCallback(async () => {
        const shareUrl = buildProfileShareUrl(profile);
        if (!shareUrl) {
            showToast(t("home.profileHeader.toasts.shareUnavailable"), "error");
            return false;
        }

        try {
            await copyTextToClipboard(shareUrl);
            showToast(t("home.profileHeader.toasts.shareCopied"), "success");
            return true;
        } catch (error) {
            console.warn("Failed to copy profile URL to clipboard.", error);
            showToast(t("home.profileHeader.toasts.shareFailed"), "error");
            return false;
        }
    }, [profile, showToast, t]);

    const clearToast = useCallback(() => {
        setToast(null);
    }, []);

    return {
        shareProfile,
        profileShareToast: toast,
        clearProfileShareToast: clearToast,
    };
}
